import Vue from 'vue'
import { fetchFavourites, addFavourite, deleteFavourite } from "@/network/favouritesRequests"

// initial state
const state = {
	items: null,
}

// getters
const getters = {
	inFavourites: state => itemId => {
		if (state.items === null) return 0
		itemId = parseInt(itemId)
		let item = state.items.find(favourite => favourite.id == itemId);
		return item !== undefined;
	},
}

// actions
const actions = {
	//retrieves favourites from server
	getFavourites({ commit }) {
		return new Promise((resolve, reject) => {
			fetchFavourites(favourites => {
				commit('setFavouritesItems', favourites)
				resolve(favourites) //calls then
			},
			errorMessage => {
				reject([]) //calls 'catch'
			})
		})
	},

	getCachedFavourites({dispatch, state}){
		if(state.items){
			return Promise.resolve(state.items)
		}else{
			return dispatch("getFavourites")
		}
	},

	doAddFavourite({commit, dispatch}, item_id){
		return new Promise((resolve, reject) => {

			//add temp item locally
			let newFavourites = state.items || [];
			newFavourites.push({id: item_id})
			commit("setFavouritesItems", newFavourites)

			//add on server
			addFavourite(item_id, result =>{
				//fetch updated
				dispatch("getFavourites")
				resolve()
			}, error =>{
				reject()
			})
		})
	},

	doDeleteFavourite({commit}, item_id){
		return new Promise((resolve, reject) => {

			//delete locally
			let newFavourites = state.items.filter(item => item.id != item_id);
			commit("setFavouritesItems", newFavourites)

			deleteFavourite(item_id, result =>{
				resolve()
			},
			error=>{
				reject()
			})
		})
	}
}

// mutations
const mutations = {
	setFavouritesItems(state, favouritesItems) {
		Vue.set(state, 'items', favouritesItems) //update cart in state
	},
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}